var map = {
	"./1.jpg": 4511,
	"./10.jpg": 7483,
	"./11.jpg": 9862,
	"./2.jpg": 7433,
	"./3.jpg": 1338,
	"./4.jpg": 2636,
	"./5.jpg": 908,
	"./6.jpg": 527,
	"./7.jpg": 6069,
	"./8.jpg": 5437,
	"./9.jpg": 4350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1199;